import React from "react";
import Accordion from "@carrier-io/air-react/Accordion";
import AccordionSummary from "@carrier-io/air-react/AccordionSummary";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import { Typography } from "@carrier-io/air-react";
import AccordionDetails from "@carrier-io/air-react/AccordionDetails";
import Box from "@carrier-io/air-react/Box";

export const UploadContentError = ({
  error,
}: {
  error: { lineNumber: number; message: string };
}) => {
  return (
    <Accordion sx={{ width: "100%" }}>
      <AccordionSummary
        aria-controls="panel1a-content"
        expandIcon={<ExpandMoreOutlinedIcon />}
        expandIconPosition="right"
        id="panel1a-header"
        statusIndicatorType="error"
      >
        <Typography
          color="error.main"
          sx={{
            marginTop: "5px",
          }}
          variant="subtitle2"
        >
          {error.lineNumber} line
        </Typography>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          padding: "0 0 0 8px",
        }}
      >
        <Typography
          sx={{
            margin: "5px 0 0 16px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography
              variant="body2"
              color="error.main"
              sx={{
                marginTop: "5px",
              }}
            >
              {error.message}
            </Typography>
          </Box>
        </Typography>
      </AccordionDetails>
    </Accordion>
  );
};
